var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82867 3.27588C7.33995 3.27588 5.91221 3.86727 4.85953 4.91995C3.80684 5.97263 3.21545 7.40038 3.21545 8.8891C3.21545 10.3778 3.80684 11.8056 4.85953 12.8582C5.91221 13.9109 7.33995 14.5023 8.82867 14.5023C10.0651 14.5023 11.2595 14.0944 12.2319 13.353L15.5087 16.6302C15.8016 16.9232 16.2765 16.9232 16.5694 16.6303C16.8623 16.3374 16.8623 15.8626 16.5694 15.5697L13.2926 12.2923C14.0339 11.3199 14.4419 10.1256 14.4419 8.8891C14.4419 7.40038 13.8505 5.97263 12.7978 4.91995C11.7451 3.86727 10.3174 3.27588 8.82867 3.27588ZM11.7514 11.7832C12.5139 11.0132 12.9419 9.97324 12.9419 8.8891C12.9419 7.7982 12.5085 6.75199 11.7372 5.98061C10.9658 5.20923 9.91956 4.77588 8.82867 4.77588C7.73778 4.77588 6.69157 5.20923 5.92019 5.98061C5.14881 6.75199 4.71545 7.7982 4.71545 8.8891C4.71545 9.97999 5.14881 11.0262 5.92019 11.7976C6.69157 12.569 7.73778 13.0023 8.82867 13.0023C9.91285 13.0023 10.9529 12.5743 11.7229 11.8118C11.7275 11.8069 11.7322 11.8021 11.737 11.7973C11.7418 11.7925 11.7466 11.7878 11.7514 11.7832Z",
    fill: "#6B6E75"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0d8922f6df508c7c91664f725fb5daae.svg";
export { ForwardRef as ReactComponent };